'use client';

import { useState } from 'react';
import { useEventListener } from '../useEventListener/useEventListener';
import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect/useIsomorphicLayoutEffect';

const DEFAULT_CALLBACK = (top: number, left: number) => {
  return top > 0;
};

export function useScrolled(callback: (top: number, left: number) => boolean = DEFAULT_CALLBACK): boolean {
  const [scrolled, setScrolled] = useState<boolean>(false);

  const onScrolled = () => {
    const scrolled_ = callback(window.scrollY, window.scrollX);
    if (scrolled !== scrolled_) {
      setScrolled(scrolled_);
    }
  };

  useEventListener('scroll', onScrolled);

  // Set size at the first client-side load
  useIsomorphicLayoutEffect(() => {
    onScrolled();

  }, []);

  return scrolled;
}
